<div class="container-fluid d-flex align-items-center justify-content-center" style="height: 100vh; width: 100%;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-8 col-md-3 col-xxl-3">
        <img alt="logo_hosp" src="../../../../assets/img/logo_hosp.png" class="img-fluid">
      </div>
    </div>
    <div class="row mt-4 justify-content-center">
      <div class="col-8 mt-4 col-md-5 col-xxl-5">
        <img alt="placeholder_forbidden" src="../../../../assets/img/pl-forbidden.jpg" class="img-fluid">
      </div>
    </div>
    <div class="row mt-4">
      <h2 class="col-12 text-center text-danger">¡Error!</h2>
      <h5 class="fw-normal text-center col-12">
        Parece que estás intentando acceder a este contenido sin autenticación
      </h5>
    </div>
   
  </div>
</div>